import {
  FormControl,
  IconButton,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@material-ui/core";
import FormHelperText from "@material-ui/core/FormHelperText";
import InputLabel from "@material-ui/core/InputLabel";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import { useTheme } from "@material-ui/styles";
import AddRowButton from "components/common/AddRowButton";
import ContentTitle from "components/common/ContentTitle";
import ButtonController from "components/request-document/components/ButtonController";
import {
  StyledTableCell,
  TableRowHead,
  useStyles,
} from "components/request-document/components/Commons";
import CompanyInfoSection from "components/request-document/components/CompanyInfoSection";
import { useFormik } from "formik";
import { SMART_T_STEP } from "libs/constant/Step";
import useModalLoading from "libs/hooks/useModalLoading";
import {
  defaultShareholder,
  getDefaultRow,
  getErrorMessage,
  isError,
  mapShareholder,
} from "libs/utils/form";
import { get } from "lodash-es";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { canEditForm } from "redux/modules/authSlice";
import { getMasterData, selectMasterData } from "redux/modules/masterSlice";
import { selectPersonalDetail } from "redux/modules/personalSlice";
import {
  selectIsChange,
  selectTypeChange,
  setIsChange,
  setSmartFormStep,
  setTypeChange,
} from "redux/modules/uiSlice";
import {
  addSmartForm,
  addSmartFormSlice,
  getSmartForm,
  getSmartFormFieldConfig,
  selectAddSmartForm,
  selectCurrentDocument,
  selectCurrentSmartForm,
  selectCurrentSmartServiceId,
  selectDraftId,
  selectSmartFormFieldConfig,
  selectSubmitSmartForm,
} from "redux/modules/visaForm";
import * as yup from "yup";

export default function UpdateCompanyInfoStep() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const theme = useTheme();
  const { showLoading, hideLoading } = useModalLoading();
  const [isSaveDraft, setSaveDraft] = useState(false);

  const submitSmartFormState = useSelector(selectSubmitSmartForm);
  const personalDetail = useSelector(selectPersonalDetail);
  const smartServiceId = useSelector(selectCurrentSmartServiceId);
  const draftId = useSelector(selectDraftId);
  const masterData = useSelector(selectMasterData);
  const smartFormFieldConfig = useSelector(selectSmartFormFieldConfig);
  const addSmartFormState = useSelector(selectAddSmartForm);
  const smartform = useSelector(selectCurrentSmartForm);
  const currentDocument = useSelector(selectCurrentDocument);
  const isChange = useSelector(selectIsChange);
  const typeChange = useSelector(selectTypeChange);

  const canEdit = useSelector(canEditForm);
  const smartNameById = (p, c) => ({ ...p, [c.smartName]: c });

  const defaultType = get(smartFormFieldConfig, "data.defaultType", []);
  const personalId = get(personalDetail, "personalID", "");
  const nationalityConfig = get(masterData, "nationalityConfig", []);

  const isSmartS = smartform?.smartserviceName === "Smart S";

  const detailList = [
    "ConditionType",
    "CompanyName",
    "OfficeNumber",

    ...(isSmartS
      ? ["Address", "CompanyWebOrEmail", "RegisterNumber"]
      : ["CompanyAddress", "CompanyWebSite", "CompanyRegisterNumber"]),

    "ProductService",
    "Shareholder",
  ];
  const detail = get(smartform, "detail", [])
    .filter((field) => detailList.includes(field.smartName))
    .reduce(smartNameById, {});

  const ConditionType = get(detail, "ConditionType.value", "");

  useEffect(() => {
    dispatch(
      getMasterData({
        nationalityConfig: true,
        JobPositionConfig: true,
        CountryConfig: true,
      })
    );
  }, [dispatch]);

  useEffect(() => {
    if (smartServiceId) {
      dispatch(getSmartFormFieldConfig({ smartserviceId: smartServiceId }));
      dispatch(
        getSmartForm({
          smartserviceId: smartServiceId,
          draftId,
          personalId,
        })
      );
    }
  }, [dispatch, draftId, personalId, smartServiceId]);

  useEffect(() => {
    if (!addSmartFormState.isLoading) {
      if (addSmartFormState.isSuccess) {
        dispatch(addSmartFormSlice.actions.clearAsyncState());

        if (isChange) {
          dispatch(setIsChange(false));
          dispatch(setTypeChange(""));
        }

        if (!isSaveDraft) {
          // dispatch(submitSmartForm({ draftId }));

          hideLoading();
          dispatch(setSmartFormStep(SMART_T_STEP.UPLOAD_DOCUMENT));
        } else {
          dispatch(
            getSmartForm({
              smartserviceId: smartServiceId,
              draftId,
              personalId,
            })
          );
          hideLoading();
        }
      } else if (addSmartFormState.isFailure) {
        hideLoading();
        alert(addSmartFormState.error?.message);
        dispatch(addSmartFormSlice.actions.clearAsyncState());
      }
    }
  }, [addSmartFormState, dispatch, hideLoading, isSaveDraft]);

  // useEffect(() => {
  //   if (!submitSmartFormState.isLoading) {
  //     if (submitSmartFormState.isSuccess) {
  //       hideLoading();
  //       dispatch(submitSmartFormSlice.actions.clearAsyncState());
  //       dispatch(setSmartFormStep(SMART_T_STEP.NONE));
  //     } else if (submitSmartFormState.isFailure) {
  //       hideLoading();
  //       alert(addSmartFormState.error?.message);
  //       dispatch(submitSmartFormSlice.actions.clearAsyncState());
  //     }
  //   }
  // }, [submitSmartFormState]);

  const callAPISubmit = async (values) => {
    showLoading();

    const { visaissuance, ...restValues } = values;
    const documentFields = Object.keys(restValues);
    const getFieldListConfig = defaultType.filter((field) =>
      documentFields.includes(field.smartName)
    );

    const getValue = (field) => {
      switch (field.smartName) {
        case "Shareholder": {
          const shareholder = get(values, field.smartName, []);
          const value = shareholder.filter((v) => !!v.NameOfCompany);
          return value || null;
        }
        default:
          return get(values, `${field.smartName}`, null);
      }
    };
    const getSmartId = (field) =>
      get(detail, `${field.smartName}.smartId`, null);

    const prepareData = {
      draftId: draftId || null,
      smartserviceId: smartServiceId,
      personalId: personalId,
      survey: null,
      visaissuance: null,
      detail: [
        ...getFieldListConfig.map((field) => ({
          smartName: field.smartName,
          smartId: getSmartId(field),
          partfromId: field.partfromId,
          configsmartId: field.configsmartId,
          linkTable: field.linkTable,
          value: getValue(field),
        })),
      ],
    };

    await dispatch(
      addSmartForm({
        data: prepareData,
      })
    );
  };

  const validationSchema = yup.object({
    // ContactEmail: yup.string().email("Invalid email format"),
  });
  const formik = useFormik({
    enableReinitialize: true,
    validationSchema,
    initialValues: {
      CompanyName: get(detail, "CompanyName.value", ""),
      OfficeNumber: get(detail, "OfficeNumber.value", ""),
      // -
      ...(isSmartS
        ? {
            Address: get(detail, "Address.value", ""),
            CompanyWebOrEmail: get(detail, "CompanyWebOrEmail.value", ""),
            RegisterNumber: get(detail, "RegisterNumber.value", ""),
          }
        : {
            CompanyAddress: get(detail, "CompanyAddress.value", ""),
            CompanyWebSite: get(detail, "CompanyWebSite.value", ""),
            CompanyRegisterNumber: get(
              detail,
              "CompanyRegisterNumber.value",
              ""
            ),
          }),

      Shareholder: getDefaultRow(
        detail,
        "Shareholder.value",
        defaultShareholder
      ).map(mapShareholder),
    },
    onSubmit: async (values) => {
      setSaveDraft(false);
      callAPISubmit(values);
    },
  });

  useEffect(() => {
    if (currentDocument.isSuccess && isChange && typeChange) {
      setSaveDraft(true);
      callAPISubmit({ ConditionType: typeChange });
    }
  }, [currentDocument.isSuccess, isChange, typeChange]);

  const mapFieldCompany = (fieldName) => {
    if (!isSmartS) return fieldName;

    switch (fieldName) {
      case "CompanyAddress":
        return "Address";
      case "CompanyWebSite":
        return "CompanyWebOrEmail";
      case "CompanyRegisterNumber":
        return "RegisterNumber";
      default:
        return fieldName;
    }
  };

  const Shareholder = get(formik.values, "Shareholder", []);

  return (
    <form onSubmit={formik.handleSubmit}>
      <ContentTitle
        title="Update Company Information"
        subTitle="Smart Visa Qualifications Update Form"
      />

      <TableContainer style={{ marginTop: 35, borderRadius: 4 }}>
        <Table className={classes.table} style={{ marginBottom: 50 }}>
          <TableHead>
            <TableRow>
              <StyledTableCell colSpan={4}>
                <div
                  className={classes.flexRow}
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <Typography
                    variant="h6"
                    style={{ fontWeight: "bold" }}
                    className={classes.title}
                  >
                    Company information
                  </Typography>
                </div>
              </StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <CompanyInfoSection
              isChangeMode
              disabledBadge
              colSpan={4}
              formik={formik}
              mapField={mapFieldCompany}
              ConditionType={ConditionType || typeChange}
            />

            <TableRow>
              <StyledTableCell colSpan={6}>
                <div className={classes.cellContent}>
                  <div className={classes.wrapField}>
                    <InputLabel>
                      Business or products or services description
                    </InputLabel>
                    <TextField
                      variant="outlined"
                      className={classes.textField}
                      name="ProductService"
                      value={formik.values.ProductService}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={isError("ProductService", formik)}
                      helperText={getErrorMessage("ProductService", formik)}
                      multiline
                      rows={5}
                      rowsMin={5}
                      rowsMax={5}
                      disabled
                    />
                  </div>
                </div>
              </StyledTableCell>
            </TableRow>

            <TableRowHead>
              <StyledTableCell>
                <div className={classes.cellContent}>
                  <Typography variant="h6" className={classes.tableTitle}>
                    Name of company shareholders (in the order of major
                    shareholders)
                  </Typography>
                </div>
              </StyledTableCell>
              <StyledTableCell>
                <Typography
                  variant="h6"
                  className={classes.tableTitle}
                  style={{ width: 200 }}
                >
                  Shares (%)
                </Typography>
              </StyledTableCell>
              <StyledTableCell colSpan={2}>
                <Typography variant="h6" className={classes.tableTitle}>
                  Nationality
                </Typography>
              </StyledTableCell>
            </TableRowHead>

            {Shareholder.map((shareholder, index) => {
              if (!shareholder.Status) return null;
              const activeIndex = Shareholder.findIndex((v) => v.Status);
              return (
                <TableRow key={index}>
                  <StyledTableCell>
                    <TextField
                      variant="outlined"
                      className={classes.textField}
                      name={`Shareholder.${index}.NameOfCompany`}
                      value={get(
                        formik.values,
                        `Shareholder.${index}.NameOfCompany`,
                        ""
                      )}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={isError(
                        `Shareholder.${index}.NameOfCompany`,
                        formik
                      )}
                      helperText={getErrorMessage(
                        `Shareholder.${index}.NameOfCompany`,
                        formik
                      )}
                      disabled={ConditionType !== "DD" || !canEdit}
                    />
                  </StyledTableCell>
                  <StyledTableCell>
                    <TextField
                      variant="outlined"
                      className={classes.textField}
                      name={`Shareholder.${index}.SharesPercent`}
                      value={get(
                        formik.values,
                        `Shareholder.${index}.SharesPercent`,
                        ""
                      )}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={isError(
                        `Shareholder.${index}.SharesPercent`,
                        formik
                      )}
                      helperText={getErrorMessage(
                        `Shareholder.${index}.SharesPercent`,
                        formik
                      )}
                      disabled={ConditionType !== "DD" || !canEdit}
                    />
                  </StyledTableCell>
                  <StyledTableCell>
                    <FormControl
                      variant="outlined"
                      className={classes.formControl}
                      style={{ width: 200 }}
                      error={isError(
                        `Shareholder.${index}.NationalityID`,
                        formik
                      )}
                      disabled={ConditionType !== "DD" || !canEdit}
                    >
                      <InputLabel>Selected nationality</InputLabel>
                      <Select
                        disabled={!canEdit}
                        label="Selected nationality"
                        name={`Shareholder.${index}.NationalityID`}
                        value={get(
                          formik.values,
                          `Shareholder.${index}.NationalityID`,
                          ""
                        )}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      >
                        {nationalityConfig.map((nationality) => (
                          <MenuItem
                            value={nationality.nationalityID}
                            key={nationality.nationalityID}
                          >
                            {nationality.nationalityName}
                          </MenuItem>
                        ))}
                      </Select>
                      <FormHelperText
                        error={isError(
                          `Shareholder.${index}.NationalityID`,
                          formik
                        )}
                      >
                        {getErrorMessage(
                          `Shareholder.${index}.NationalityID`,
                          formik
                        )}
                      </FormHelperText>
                    </FormControl>
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    {index > 0 && ConditionType === "DD" ? (
                      <IconButton
                        style={{ width: 40, color: theme.palette.error.main }}
                        size="small"
                        onClick={async () => {
                          if (
                            get(
                              formik.values,
                              `Shareholder[${index}].shareholderId`,
                              ""
                            )
                          ) {
                            formik.setFieldValue(
                              `Shareholder[${index}].Status`,
                              false
                            );
                          } else {
                            formik.setFieldValue(
                              "Shareholder",
                              Shareholder.filter((__, i) => i !== index)
                            );
                          }
                        }}
                      >
                        <DeleteForeverIcon />
                      </IconButton>
                    ) : (
                      <div style={{ width: 40 }} />
                    )}
                    <FormHelperText error={false}> </FormHelperText>
                  </StyledTableCell>
                </TableRow>
              );
            })}

            <TableRow>
              <StyledTableCell colSpan={4}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <AddRowButton
                    disabled={ConditionType !== "DD" || !canEdit}
                    onClick={() => {
                      formik.setFieldValue("Shareholder", [
                        ...Shareholder,
                        mapShareholder(defaultShareholder),
                      ]);
                    }}
                  />
                </div>
              </StyledTableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>

      <ButtonController
        onClickSaveDraft={() => {
          setSaveDraft(true);
          callAPISubmit(formik.values);
        }}
      />
    </form>
  );
}
